import * as React from "react";
import LicenseTrafficViolationNotification from "./LicenseTrafficViolationNotification";
import useLicenseTrafficViolation, { acknowledgeTrafficViolation } from "./useLicenseTrafficViolation";
const LicenseTrafficViolationNotificationContainer = () => {
  const { acknowledged, invalidateTrafficViolation } = useLicenseTrafficViolation();
  const acknowledgeViolationNotification = () => {
    acknowledgeTrafficViolation().then(() => invalidateTrafficViolation());
  };
  const shouldShowNotification = acknowledged !== void 0 && !acknowledged;
  return /* @__PURE__ */ React.createElement("div", null, shouldShowNotification && /* @__PURE__ */ React.createElement(LicenseTrafficViolationNotification, { onDismissNotification: acknowledgeViolationNotification }));
};
export default LicenseTrafficViolationNotificationContainer;
